import type { CSSProperties, ReactElement, ReactNode } from 'react';

import { getIcon, type NotificationType } from './getIcon';
import CloseBtn from 'Components/UI_Library/Icons/CloseBtn';
import classes from './Notification.module.css';

type Props = {
    title?: string | ReactNode;
    message?: string | ReactNode;
    type?: NotificationType;
    isError?: boolean;
    isBlue?: boolean;
    extraClass?: string;
    style?: CSSProperties;
    children?: ReactNode;
    handleCloseMsg?: () => void;
    noCloseBtn?: boolean;
    buttons?: ReactNode;
    noIcon?: boolean;
};

const Notification = (props: Props): ReactElement | null =>
    props.message ? (
        <div
            className={`${classes.alert} ${props.type ? classes[props.type] : classes.alertSuccess} ${
                props.isError ? classes.alertDanger : ''
            } ${props.isBlue ? classes.blue : ''} ${props.extraClass}`}
            style={{ ...props.style }}
        >
            {props.message !== 'ERROR_NETWORK_CONNECTION' ? (
                <>
                    {props.type && !props.noIcon && (
                        <img
                            alt={`${props.type} notification icon`}
                            className={classes.notificationIcon}
                            src={getIcon(props.type)}
                        />
                    )}
                    <div className={classes.notificationMessage}>
                        {props.title && <span className={classes.title}>{props.title}</span>}
                        <span>{props.message}</span>
                        {props.children && <span>{props.children}</span>}
                    </div>
                </>
            ) : (
                <span>There was an error. Please check your network connectivity and try again.</span>
            )}
            {props.buttons}
            {!props.noCloseBtn && (
                <button type="button" className={classes.closeButton} onClick={props.handleCloseMsg}>
                    <CloseBtn />
                </button>
            )}
        </div>
    ) : null;

export default Notification;
